import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { getHapticsEnabled, setHapticsEnabled } from '@/services/haptics';
import { isNativePlatform } from '@/services/platform';

const HapticSettings: React.FC = () => {
  const [enabled, setEnabled] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const native = isNativePlatform();

  useEffect(() => {
    if (!native) return;
    void getHapticsEnabled().then(setEnabled);
  }, [native]);

  if (!native) return null;

  const toggle = async () => {
    if (isSaving) return;
    const next = !enabled;
    setEnabled(next);
    setIsSaving(true);
    try {
      await setHapticsEnabled(next);
    } catch {
      setEnabled(!next);
      toast.error('Could not save haptic settings.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <section className="bg-surface-card p-4 md:p-6 rounded-lg shadow-xl mb-8">
      <h2 className="font-heading text-2xl text-accent-yellow mb-4">App Feedback</h2>
      <div className="flex items-center justify-between gap-4 py-2">
        <div>
          <p className="text-sm font-semibold text-gray-100">Haptic Feedback</p>
          <p className="text-xs text-gray-400">Vibrate for live scores, draft alerts, and confirmations</p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          aria-label="Haptic feedback"
          disabled={isSaving}
          onClick={toggle}
          className={`relative inline-flex h-8 w-14 flex-shrink-0 rounded-full transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-yellow ${
            enabled ? 'bg-accent-yellow' : 'bg-gray-600'
          } ${isSaving ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <span
            className={`inline-block h-7 w-7 mt-0.5 rounded-full bg-white shadow transform transition-transform duration-150 ${
              enabled ? 'translate-x-6' : 'translate-x-0.5'
            }`}
          />
        </button>
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Your device’s Reduce Motion preference always disables haptics automatically.
      </p>
    </section>
  );
};

export default HapticSettings;
